export class User {
  username:string;
  balance:number;

  constructor(username:string, balance:number) {
    this.username = username;
    this.balance = balance;
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/user.ts